import { Navigate, Route, Routes } from 'react-router';
import './App.css';
import ContainerDashboard from './components/dashboard/container-dashboard';
import Layout from './pages/auth/route/layout';
import PersistLogin from './pages/auth/route/persist-login';
import RequiredAuth from './pages/auth/route/required-auth';
import GuestRoute from './pages/auth/route/guest-route';
import { ToastContainer, Zoom } from 'react-toastify';
import { DEPARTMENT_CODES } from './constant/department-code-constant';
import AccountSettingsPage from './pages/general/account-settings-page';
import ComputationProposalPage from './pages/actuarial-department/computation-proposal-page';
import UserManagementPage from './pages/it-department/user-management-page';
import CreateAccountPage from './pages/it-department/create-account-page';
import StatusProposalPage from './pages/gms-department/status-proposal-page';
import CreateProposalPage from './pages/gms-department/create-proposal-page';
import LoginPage from './pages/auth/login-page';
import NotFoundPage from './pages/auth/not-found-page';
import UnauthorizedPage from './pages/auth/unauthorized-page';
import ExtensionRequestProposalPage from './pages/gms-department/extension-request-proposal-page';
import CategoryManagement from './pages/it-department/category-management';
import RequestAmendmentsPage from './pages/actuarial-department/request-amendments-page';
import PolicyCreationPage from './pages/ebam-department/policy-creation-page';
import COCGenerationPage from './pages/ebam-department/coc-generation-page';
import ComputationReviewPage from './pages/actuarial-department/computation-review-page';
import AuthenticatedAppLayout from './pages/layout/authenticated-app-layout';
import ActuarialLayout from './pages/layout/actuarial-layout';
import MarketingGMSLayout from './pages/layout/marketing-gms-layout';
import EBAMLayout from './pages/layout/ebam-layout';
import ITLayout from './pages/layout/it-layout';
import ActuarialDashboard from './pages/actuarial-department/actuarial-dashboard';
import AllRequestApprovalPage from './pages/actuarial-department/all-request-approval-page';
import NetworkStatusMonitor from './pages/layout/network-status-monitor';
import FranchiseGroupChecker from './pages/gms-department/franchise-group-checker';
import ConflictProposalApproval from './pages/gms-department/conflict-proposal-approval';
import TransferOwnershipProposalPage from './pages/gms-department/transfer-ownership-proposal-page';
import MyTeamLayout from './pages/layout/my-team-layout';
import { selectUserCredentials } from './features/auth/auth-slice';
import { useSelector } from 'react-redux';
import { usePolicyDataState } from './hooks/policy/use-policy-data-state';
import { useProposalTypeData } from './hooks/proposal/use-proposal-type-data';
import { selectGCLIRates6670 } from './features/actuarial/rates-slice';
import NotificationMonitor from './pages/layout/notification-monitor';
import CFEChatsPage from './pages/gms-department/general-chat';
import BillingPage from './pages/ebam-department/billing-page';
import CreateRenewal from './pages/gms-department/create-renewal';
import Proposals from './pages/gms-department/proposals';

function App() {

  return (
    <>
      <ToastContainer
        position="top-center"
        closeButton={false}
        autoClose={false}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
        transition={Zoom}
      />
      {/* <NotificationMonitor/> */}
      <NetworkStatusMonitor/>
      <Routes>
        <Route path="/" element={<Layout />}>

          <Route path="/unauthorized" element={<UnauthorizedPage />}/>
          <Route path="*" element={<NotFoundPage />}/>

          <Route element={<PersistLogin />}>

            <Route element={<GuestRoute />}>
              <Route path='/login' element={<LoginPage />}/>
              <Route index element={<Navigate to="/login" replace />}/>
            </Route>
            
            <Route element={<AuthenticatedAppLayout/>}>
              <Route element={<ContainerDashboard/>}>
                <Route element={<RequiredAuth allowedDepartmentCode={[ 
                  DEPARTMENT_CODES.MKT_GMS, 
                  DEPARTMENT_CODES.MONITORING_DEPT_GMS
                ]}/>}>
                  <Route element={<MarketingGMSLayout/>}>
                    <Route path="/create-proposal" element={<CreateProposalPage />}/>
                    <Route path="/status-proposal" element={<StatusProposalPage />}/>
                    <Route path="/request-extension-proposal" element={<ExtensionRequestProposalPage />}/>
                    <Route path="/existing-group-requests" element={<ConflictProposalApproval />}/>
                    <Route path="/transfer-ownership-proposal" element={<TransferOwnershipProposalPage />}/>

                    <Route path="/renewal" element={<CreateRenewal />}/>
                    {/* <Route path="/proposals" element={<Proposals />}/> */}
                    {/* <Route path="/chats" element={<CFEChatsPage />}/> */}
                    {/* <Route path="/my-team" element={<MyTeam />}/> */}
                  </Route>
                </Route>
                <Route element={<RequiredAuth allowedDepartmentCode={[
                  DEPARTMENT_CODES.ACTUARIAL,
                  DEPARTMENT_CODES.MONITORING_DEPT_ACTUARIAL,
                ]}/>}>
                  <Route element={<ActuarialLayout/>}>
                    <Route path='/computation-proposal' element={<ComputationProposalPage />}/>
                    <Route path='/my-approval-requests' element={<ComputationReviewPage />}/>
                    <Route path='/approval-requests' element={<AllRequestApprovalPage />}/>
                    <Route path='/request-amend' element={<RequestAmendmentsPage />}/>
                  </Route>
                </Route>
                <Route element={<RequiredAuth allowedDepartmentCode={[ DEPARTMENT_CODES.EBAM ]}/>}>
                  <Route element={<EBAMLayout/>}>
                    <Route path="/policy-creation" element={<PolicyCreationPage />}/>
                    <Route path="/coc-generation" element={<COCGenerationPage />}/>
                    {/* <Route path="/coc-generation" element={<BillingPage />}/> */}
                    {/* <Route path="/policy-review" element={<COCGenerationPage />}/> */}
                  </Route>
                </Route>
                <Route element={<RequiredAuth allowedDepartmentCode={[ DEPARTMENT_CODES.IT ]}/>}>
                  <Route element={<ITLayout/>}>
                    <Route path="/new-user" element={<CreateAccountPage />}/>
                    <Route path="/user-management" element={<UserManagementPage />}/>
                    <Route path="/system-configuration" element={<CategoryManagement />}/>
                  </Route>
                </Route>
                <Route element={<RequiredAuth allowedDepartmentCode={[ 
                  DEPARTMENT_CODES.ACTUARIAL,
                  DEPARTMENT_CODES.IT,
                  DEPARTMENT_CODES.MKT_GMS,
                  DEPARTMENT_CODES.EBAM,
                  DEPARTMENT_CODES.MONITORING_DEPT_GMS,
                  DEPARTMENT_CODES.MONITORING_DEPT_ACTUARIAL,
                ]}/>}>
                  <Route path="/my-team" element={<MyTeamLayout />}/>
                  {/* <Route path="/my-team" element={<BillingPage />}/> */}
                  <Route path='/my-account' element={<AccountSettingsPage />}/>
                </Route>
              </Route>
            </Route>
          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;